import { gql } from '@apollo/client/core';

export default gql`
  query PgExternalDataEntryLogin($emailAddress: String!, $shareToken: String!) {
    validateDelegation(emailAddress: $emailAddress, shareToken: $shareToken)
  }
`;
